import { APK_PLATFORMS, DESKTOP_PLATFORMS } from "../constants";

export type DeviceFamily = "quest" | "pico" | "android";

export function isApkPlatform(platform: string): boolean {
  return APK_PLATFORMS.includes(platform);
}

export function isDesktopPlatform(platform: string): boolean {
  return DESKTOP_PLATFORMS.includes(platform);
}

export function isQuestPlatform(platform: string): boolean {
  return ["OculusQuest", "MetaQuest"].includes(platform);
}

export function isWebGLPlatform(platform: string): boolean {
  return ["WebGLApp", "WebGL App"].includes(platform);
}

/** Detect device family from USB productName */
export function detectDeviceFamily(productName: string, manufacturerName = ""): DeviceFamily {
  const name = productName.toLowerCase();
  const manufacturer = manufacturerName.toLowerCase();
  if (name.includes("quest") || manufacturer.includes("oculus") || manufacturer.includes("meta")) {
    return "quest";
  }
  if (name.includes("pico") || manufacturer.includes("pico")) return "pico";
  return "android";
}

/** Check if a build platform is compatible with the connected device */
export function isPlatformCompatible(targetPlatform: string, deviceFamily: DeviceFamily): boolean {
  switch (targetPlatform) {
    case "MetaQuest":
    case "OculusQuest":
      return deviceFamily === "quest";
    case "PicoNeo":
      return deviceFamily === "pico";
    case "Android":
      return deviceFamily === "android";
    default:
      return false;
  }
}
